enum Cookie {
  AUTHENTICATION_COOKIE = 'APIAUTH',

  ANONYMOUS_SESSION_COOKIE = 'BRID',

  XSRF_COOKIE = 'XSRF-TOKEN',

  // This was added many many years ago and powers a flash message after a user logs out and is redirected to the
  // homepage
  LOGOUT_INDICATOR_COOKIE = 'USER_LOGOUT',

  // JSON string to override specific feature flags (used primarily in automated tests)
  FEATURE_FLAG_OVERRIDES = 'FEATURE-FLAG-OVERRIDES',
}

export default Cookie
